import { Flex, MenuProps } from 'antd';
import React from 'react';
import { ReactComponent as PersonFill } from 'assets/icons/PersonFill.svg';
import { FileFilled } from '@ant-design/icons';
import { getSsoPlatforms } from '_technical/utils/sso.utils';

export type MenuItem = Required<MenuProps>['items'][number];

// Base navigation menus
const baseMenus = [
  {
    key: '/',
    label: 'Mes projets',
    icon: <FileFilled />,
  },
  {
    key: '/profile',
    label: 'Mon profil',
    icon: <PersonFill />,
  },
];

// SSO Platform menus
const getSsoPlatformMenus = () => {
  const platforms = getSsoPlatforms();
  return platforms.map((platform) => ({
    key: `/pending?redirect_url=${encodeURIComponent(platform.domain)}`,
    label: (
      <span className="flex items-center gap-2">
        {platform.plateformName}
        <img
          src="/platforms/external-link.svg"
          alt=""
          className="h-2 w-2 rotate-180"
        />
      </span>
    ),
    icon: (
      <img
        src={platform.logoUrl}
        alt={platform.plateformName}
        style={{ width: 20, height: 20, objectFit: 'contain' }}
      />
    ),
  }));
};

// Combined navigation menus
export const navigationMenus = [...baseMenus, ...getSsoPlatformMenus()];

const navigationConfig = (onClick?: (e: any) => void): MenuItem[] =>
  navigationMenus.map((menu) => {
    return {
      ...menu,
      onClick,
      icon: (
        <Flex style={{ width: 24 }} justify={'center'}>
          {menu.icon}
        </Flex>
      ),
    };
  });

export default navigationConfig;
